export default __webpack_public_path__ + "static/media/avatar_76.47173482.png";